import React from "react";
import { List, EditButton, FileField, TextField } from "react-admin";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import Typography from "@material-ui/core/Typography";
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";
import { NAME } from "../../configs/index";
import Actions from '../Actions'
const cardStyle = {
  width: 300,
  margin: "0.5em",
  display: "inline-block",
  verticalAlign: "top"
};
const CommentGrid = ({ ids, data, basePath }) => {
  return (
    <div style={{ margin: "1em" }}>
      {ids.map(id => (
        <Card key={id} style={cardStyle}>
          <Typography style={{ padding: "8px 12px" }} variant="headline">
            {NAME}
          </Typography>
          {data[id].about_file && data[id].about_file.url ? (
            <div style={{ padding: "8px 12px" }}>
              <PictureAsPdf
                style={{
                  width: 30,
                  height: 30,
                  marginRight: 10,
                  color: "gray"
                }}
              />
              <FileField
                target="_blank"
                record={data[id]}
                source="about_file.url"
                title={`About ${NAME}`}
              />
            </div>
          ) : (
              <div style={{ padding: "8px 12px" }}>
                <PictureAsPdf
                  style={{
                    width: 30,
                    height: 30,
                    marginRight: 10,
                    color: "gray"
                  }}
                />
                <Typography
                  style={{ display: "inline" }}
                  variant="subheading"
                  color="textSecondary"
                >
                  No file
              </Typography>
              </div>
            )}
          <CardActions style={{ float: "right" }}>
            <EditButton
              resource="posts"
              basePath={basePath}
              record={data[id]}
            />
          </CardActions>
        </Card>
      ))}
    </div>
  );
};
CommentGrid.defaultProps = {
  data: {},
  ids: []
};

const AboutList = props => {
  return (
    <List title="about.about" {...props} actions={<Actions />}>
      <CommentGrid />
    </List>
  );
};

export { AboutList };



// WEBPACK FOOTER //
// ./src/components/about/AboutList.js